module.exports = __webpack_public_path__ + "assets/img/2.0ae3fd78.gif";